var Payment = xClass("MiQuickgamePayment")
Payment.prototype.ctor = function () {

}


Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[####]call mi pay id:"+data.productId)
    let productId = data.productId

    function onSuccess(resp) {
        let data = resp.data
        let orderId = data.orderId;

        let orderInfo = JSON.parse(decodeURIComponent(data.orderInfo))
        
        console.log("[################]mi pay getinfohttp success", data, "orderInfo", orderInfo)

        let payment = {
            orderInfo: orderInfo,
            success: function() {
                successCallback && successCallback({orderId});
            },
            fail: function (res) {
                console.log("[######]fail res:"+JSON.stringify(res))
                // let fail_type = self.getFailType(res.code);
                failCallback({
                    code: res.resultStatus,
                    data: res.memo,
                    msg: res.memo,
                })
            }
        }
        cc.log("mi pay", JSON.stringify(payment))
        mini.pay(payment)


       
        // let balance = data.balance
        // let cash = data.cash
        // //data.paySign//后端生成的签名的时间戳
        // console.log("[#############]mi pay data "+ JSON.stringify(data))
        // if (!balance || balance < cash) {
        //     // 余额不足，充值

        // } 
        // else 
        // {
        //     // 余额够，不需要充值，直接购买
        //     //pay()
        // }
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = MiQuickgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId:productId,
        openid: META.user.openid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        engineVersion:META.platformVersion,
        ext: data.ext
    })
    console.log("[####]mi pay:"+META.platformVersion)
}

module.exports = Payment